<template>
  <div>
    <el-tabs v-model="activeName" style="margin-top: 15px;" type="card">
      <el-tab-pane label="业务记录" name="业务记录">
        <business-record></business-record>
      </el-tab-pane>
      <el-tab-pane label="用户列表" name="用户列表">
        <member-list></member-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import businessRecord from './records/businessRecord.vue';
import memberList from './records/memberList.vue';

export default {
  components: {
    businessRecord,
    memberList
  },
  data() {
    return {
      activeName: '业务记录'
    };
  }
};
</script>
